module.exports = __webpack_public_path__ + "static/media/jcb.f14a2c3c.png";